module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item.hasMenu && _vm.canShow(_vm.type, _vm.item.path)) ? _c('li', {
    staticClass: "c-menu__item",
    class: {
      'has-sub': _vm.hasNext(),
      'line-through': _vm.item.inactive && !_vm.parentRoute
    }
  }, [(_vm.item.hasLink && _vm.item.hasMenu && !_vm.item.hasOwnProperty('fullRoute')) ? _c('router-link', {
    staticClass: "c-menu__link",
    attrs: {
      "to": _vm.getRoute()
    }
  }, [(_vm.item.iconMenu) ? _c('div', {
    staticClass: "c-menu__icon"
  }, [_c('i', {
    class: _vm.item.iconMenu
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-menu__text"
  }, [_vm._v(_vm._s(_vm.label))])]) : (_vm.item.hasLink && _vm.item.hasMenu && _vm.item.hasOwnProperty('fullRoute')) ? _c('a', {
    staticClass: "c-menu__link",
    attrs: {
      "href": _vm.item.fullRoute
    }
  }, [(_vm.item.iconMenu) ? _c('div', {
    staticClass: "c-menu__icon"
  }, [_c('i', {
    class: _vm.item.iconMenu
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-menu__text"
  }, [_vm._v(_vm._s(_vm.label))])]) : _c('a', {
    staticClass: "c-menu__link",
    attrs: {
      "href": "#"
    }
  }, [(_vm.item.iconMenu) ? _c('div', {
    staticClass: "c-menu__icon"
  }, [_c('i', {
    class: _vm.item.iconMenu
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-menu__text"
  }, [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _vm._l((_vm.item.children), function(action) {
    return (_vm.hasNext()) ? _c('ul', {
      key: action.label,
      staticClass: "c-menu"
    }, [_c('menu-sidebar-item', {
      attrs: {
        "type": _vm.type,
        "item": action,
        "parentRoute": _vm.getRoute(),
        "level": 2
      }
    })], 1) : _vm._e()
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15e23ec6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/MenuSidebarItem.vue
// module id = 2935
// module chunks = 0